<section class="pt-2 ">
  <div class="">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>
          {{ isFormView ? 'Registrar detalle de salida de inventario' : 'Detalle de salida de inventario' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledButton" [width]="'7rem'"
          (onClick)="openArticleSelectionModal()"></app-custom-button>
        <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Artículos'"
          [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
          (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-inventory-output-detail [inventoryOutputModel]="inventoryOutputModel"
          [inventoryOutputDetailContract]="inventoryOutputDetail" [permissionUpdatable]="permissionUpdatable"
          [swAllowsNegativeShopBalances]="swAllowsNegativeShopBalances" (isFormView)="getFormView($event)"
          (updateListDetail)="getInventoryOutputDetails()">
        </app-register-inventory-output-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !this.disabledButton " [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getInventoryOutputDetails()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>